(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name MemberAppController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('MemberAppController', MemberAppController);

    MemberAppController.$inject = ['$uibModal','$timeout','$http','UserService','AddressService','$scope','upload','StripeService'];


    function MemberAppController($uibModal,$timeout,$http,UserService,AddressService,$scope,upload,StripeService)
    {
		var stripe = Stripe('pk_live_4PwOGHjbnxb56xV50VfY9Qig');
		var card  = null;
		var elements = null;
		/*
		https://stripe.com/docs/testing
		No authentication (default U.S. card): 4242 4242 4242 4242.
		Authentication required: 4000 0027 6000 3184.
		*/
      	var vm = this;
      	vm.paymentModal = "";
      	vm.donation = {}; 
      	vm.account = null;
      	vm.committee=[];
        vm.custom = [];
        vm.insertDocumentation = false;
        vm.membership="Regular Member";
        vm.document_id = null;
        vm.currency = "$";


        vm.memberships =[
            "Regular Member",
            "Student Member",
            "Affiliated Collective Member",
            "Complimentary Collective",
            "Grant Membership",
            "Member Prospect",
            "Regular Collective Member",
            "Life Member"
        ];

        vm.swapDonation = []; 

        vm.stripe = StripeService;
      	
    		vm.amount = 0;
    		vm.errorAmount = false;
    		vm.as = AddressService;
		
	      vm.journalRadio = function(code){
           delete vm.donation[0];
           angular.forEach(vm.committee,function(value,key){
             if(value.code != code && value.format_code=="Subs"){
                if(vm.donation[value.code]!==undefined)delete vm.donation[value.code];
             }
             
           });
        }

        vm.resetJournals = function(){
          var code = 0;
          angular.forEach(vm.committee,function(value,key){
             if(0 == code ){
               if(value.code != 0 && value.format_code=="Subs")
                  delete vm.donation[value.code];
             }
           });
        }

    		vm.setAmount = function(){
          $timeout(function(){
            vm.amount = 0 ;
            angular.forEach(vm.donation,function(value,key){
              console.log("key "+key+" value "+value );
              if(value)
                vm.amount = vm.amount + parseInt(value);
            });
            console.log(vm.amount);
       
          });
    			
    		};

        vm.setCategory = function(category)
        {
          if(category == 'Student Member' || category == 'Life Member' )
          {
            vm.insertDocumentation = true;
          }else{
            vm.insertDocumentation = false;
          }


        };

      	vm.updatePrices = function(val,cat)
        {
          console.log(val);
          console.log(cat);
          console.log(this);
          var isOther = false;
          if(val=='other')
          {
            val = vm.donation[cat];
            isOther = true;

          }

            if(vm.swapDonation[cat]!==val)
            {
              vm.swapDonation[cat] = val;
            }else{

              if(isOther)
                vm.custom[cat]=1;

              vm.swapDonation[cat] = 0;
              vm.donation[cat]=0;
            }

          vm.setAmount();
          console.log(vm.donation);
        };


         vm.reloadAccount = function()
          {
            UserService.getAccount().then(function(data){
              console.log(data);
              vm.account = data.account;
              $scope.$broadcast("refresh_select2");
            });

        };

        vm.reloadProducts = function(code)
        {
          UserService.getProducts(vm.as,vm.membership,code).then(function(data)
          {
            vm.committee = data.products;
            vm.currency = data.currency;
            StripeService.currency = data.currency;
          });

        };

       

      vm.submit = function()
      {
        vm.errorAmount = false;

        vm.setAmount();

        if(vm.amount > 0 )
        {
          if(vm.insertDocumentation && vm.document_id)
          {
            console.log("ENTRAMOS");
            vm.stripe.setProducts(vm.donation);
            vm.stripe.setAmount(vm.amount);
            console.log("ENVIAMOS");
            vm.stripe.PaymentWithDoc().then(function(){
              vm.amount = 0;
               angular.forEach(vm.donation,function(value,key){
                  vm.donation[key] = 0;
               });
            });

          }else if( vm.stripe.fullname !== "" && !vm.stripe.cardError){
            vm.stripe.setProducts(vm.donation);
            vm.stripe.setAmount(vm.amount);
            vm.stripe.submitForm().then(function(){
               vm.amount = 0;
               angular.forEach(vm.donation,function(value,key){
                  vm.donation[key] = 0;
               });
            });
          }else{
            vm.errorAmount = true;  
          }

        }
        else{
          vm.errorAmount = true;
        }
      };

      vm.upload = function(response)
      {

        console.log(response.data);
        if(response.data.code == "404"){
          vm.stripe.openMsg("Documentation","Error","Upload error");
        }else{
          vm.document_id =  response.data.document;
          vm.stripe.document_id =  response.data.document;
          vm.document_name =  response.data.name;
        }


      };

      vm.closeDocument = function()
      {
          vm.document_id =  null;
          vm.stripe.document_id =  null;
          vm.document_name =  null;

      };    

      
      vm.reloadAccount();
      vm.as.reloadAddresses().then(function(){
        vm.reloadProducts();
      });
      vm.stripe.init();
       

    }
})();